// Recovered compiled webpack factory 79889. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "PromiseQueue", {
      enumerable: !0,
      get: function () {
        return u;
      },
    }));
  let n = r(15903),
    a = r(17797);
  var o = a._("_maxConcurrency"),
    i = a._("_runningCount"),
    s = a._("_queue"),
    l = a._("_processNext");
  class u {
    enqueue(e) {
      let t,
        r,
        a = new Promise((e, n) => {
          ((t = e), (r = n));
        }),
        o = async () => {
          try {
            n._(this, i)[i]++;
            let r = await e();
            t(r);
          } catch (e) {
            r(e);
          } finally {
            (n._(this, i)[i]--, n._(this, l)[l]());
          }
        };
      return (n._(this, s)[s].push({ promiseFn: a, task: o }), n._(this, l)[l](), a);
    }
    bump(e) {
      let t = n._(this, s)[s].findIndex((t) => t.promiseFn === e);
      if (t > -1) {
        let e = n._(this, s)[s].splice(t, 1)[0];
        (n._(this, s)[s].unshift(e), n._(this, l)[l](!0));
      }
    }
    constructor(e = 5) {
      (Object.defineProperty(this, l, { value: c }),
        Object.defineProperty(this, o, { writable: !0, value: void 0 }),
        Object.defineProperty(this, i, { writable: !0, value: void 0 }),
        Object.defineProperty(this, s, { writable: !0, value: void 0 }),
        (n._(this, o)[o] = e),
        (n._(this, i)[i] = 0),
        (n._(this, s)[s] = []));
    }
  }
  function c(e) {
    if (
      (void 0 === e && (e = !1),
      (n._(this, i)[i] < n._(this, o)[o] || e) && n._(this, s)[s].length > 0)
    ) {
      var t;
      null == (t = n._(this, s)[s].shift()) || t.task();
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
